import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback';
import Image from 'Components/frameworks/image/Image';
import { Title } from 'Components/frameworks/title/Title';
const WECHAT_TUTORIAL_IMAGE = 'https://ns.clubmed.com/it/2018/be/payment/wechat.png';
type Props = {
  hasTransactionExpired?: boolean;
};
export const WeChatTutorial = ({ hasTransactionExpired = false }: Props) => (
  <div className="w-full">
    <Title className="mb-10" theme="title-brand-n2">
      {t('common.payment.wechat.qrCode.title')}
    </Title>
    <Capsule header="none">
      {hasTransactionExpired && (
        <FormFeedback
          className="flex justify-center text-red"
          isError
          message={t('common.payment.wechat.qrCode.expired')}
        />
      )}
      <div
        className={classnames('text-center', {
          'pt-[33px]': !hasTransactionExpired,
        })}
      >
        <div className="highlited-text text-sienna">
          {t('common.payment.wechat.qrCode.subtitle')}
        </div>
        <div className="subheader">{t('common.payment.wechat.qrCode.label')}</div>
      </div>
      <Image
        altMsg="tutorial to use wechat"
        className="relative left-[30px] mx-auto my-20 w-[420px]"
        dimensions={{
          h: 313,
          w: 420,
        }}
        imageUrl={WECHAT_TUTORIAL_IMAGE}
      />
    </Capsule>
  </div>
);
